import { setResize } from "../../utils/set-resize";

export const accordion = (): void => {
  // .c-accordion（--open で開閉）
  const accordionContainers = document.querySelectorAll(".c-accordion");
  const accordionSpContainers = document.querySelectorAll(".c-accordion-sp");
  accordionContainers.forEach((container) => {
    const items = Array.from(container.children).filter((child) => child.classList.contains("c-accordion__item"));
    items.forEach((item) => {
      let resizeTimeout: NodeJS.Timeout;
      const btn = item.querySelector<HTMLButtonElement>(".c-accordion__btn");
      btn?.addEventListener("click", function () {
        item.classList.toggle("--open");
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => setResize(), 1000);
      });
    });
  });
  if (window.innerWidth < 768) {
    accordionSpContainers.forEach((container) => {
      const items = Array.from(container.children).filter((child) => child.classList.contains("c-accordion-sp__item"));
      items.forEach((item) => {
        let resizeTimeout: NodeJS.Timeout;
        const btn = item.querySelector<HTMLButtonElement>(".c-accordion-sp__btn");
        btn?.addEventListener("click", function () {
          item.classList.toggle("--open");
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(() => setResize(), 1000);
        });
      });
    });
  }
};
